import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { RegistryItemSampleBoard } from '@app/strain/materials/models/registry-item-sample-board';
import { SampleBoard } from '@app/strain/sample-boards/models/sample-board.model';
import { ModalComponent } from '@app/shared/components';

@Component({
    selector: 'app-strain-sample-board-load-modal',
    templateUrl: './strain-sample-board-load-modal.component.html',
    styleUrls: ['./strain-sample-board-load-modal.component.scss']
})
export class StrainSampleBoardLoadModalComponent {
    @ViewChild('modal', { static: true }) modal: ModalComponent;

    @Input() sampleBoards: RegistryItemSampleBoard[] = [];
    @Input() isLoading = false;

    @Output() load = new EventEmitter<number>();

    public sampleBoardSelectorControl = new UntypedFormControl(null, Validators.required);

    open() {
        this.sampleBoardSelectorControl.setValue(this.availableSampleBoards[0] || null);
        this.modal?.open();
    }

    close() {
        this.modal?.close();
        this.sampleBoardSelectorControl.reset();
    }

    onLoadClicked() {
        if (!this.selectedSampleBoardId) {
            return;
        }

        this.load.emit(this.selectedSampleBoardId);
    }

    get availableSampleBoards(): SampleBoard[] {
        return (this.sampleBoards || [])
            .map(item => item?.sampleBoard)
            .filter(board => !!board?.id);
    }

    private get selectedSampleBoardId(): number | null {
        const selectedSampleBoard = this.sampleBoardSelectorControl.value;
        const raw = selectedSampleBoard && typeof selectedSampleBoard === 'object'
            ? selectedSampleBoard.id
            : selectedSampleBoard;
        return Number(raw) || null;
    }
}
